export default __webpack_public_path__ + "media/2a526065a5c3f5390cbd7fe4918a4a4ae90b8c1a6a545a6652d95ee06e56d484.svg";